import { Clear, MoreVert, Search } from '@mui/icons-material';
import { Box, Button, IconButton, InputAdornment, Menu, styled, TextField } from '@mui/material';
import { DataGridPro, GridToolbarColumnsButton, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import { FC, useState } from 'react';

export interface DataGridToolbarProps {
  csvFileName?: string;
  onClearFilters?: () => void;
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
}

export interface DataGridEmptyProps {
  emptyRowsMessage: string;
}

const DataGridStriped = styled(DataGridPro)(({ theme }) => ({
  '.MuiDataGrid-row:nth-of-type(2n)': {
    backgroundColor: theme.palette.grey[200],
  },
  '.MuiDataGrid-columnHeaderTitle': {
    color: theme.palette.primary.main,
  },
  '.MuiDataGrid-row': {
    ':hover': {
      cursor: 'pointer',
    },
  },
}));

export const DataGridToolbar: FC<DataGridToolbarProps> = (props: DataGridToolbarProps): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    event.preventDefault();
    props.setSearchValue(event.currentTarget.value);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box p={2} display="flex" flexDirection="column" gap={2}>
      <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        {props.onClearFilters && (
          <Button startIcon={<Clear />} onClick={props.onClearFilters} size="small">
            Clear Filters
          </Button>
        )}
        <Box flexGrow={1} />
        {props.csvFileName && <GridToolbarExport csvOptions={{ fileName: props.csvFileName }} />}
      </Box>
      <Box display="flex" flexDirection="column">
        <Box display="flex" alignItems="center" gap={4}>
          <TextField
            sx={{ flex: 1 }}
            value={props.searchValue}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            fullWidth
            placeholder="Search"
          />
          <IconButton onClick={handleClick} sx={{ display: { xs: 'flex', sm: 'none' } }} size="small">
            <MoreVert />
          </IconButton>
          <Menu anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} anchorEl={anchorEl} open={open} onClose={handleClose}>
            <Box display="flex" flexDirection="column">
              <GridToolbarColumnsButton />
              <GridToolbarFilterButton />
              {props.csvFileName && <GridToolbarExport csvOptions={{ fileName: props.csvFileName }} />}
              {props.onClearFilters && (
                <Button startIcon={<Clear />} onClick={props.onClearFilters} size="small">
                  Clear Filters
                </Button>
              )}
            </Box>
          </Menu>
        </Box>
      </Box>
    </Box>
  );
};

export default DataGridStriped;
